<template>
  <div class="login">
    <!--头部导航-->
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="找回密码" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content clear">
      <van-cell-group>
        <van-field type="text" placeholder="请输入手机号" label="手机号" v-model="mobile"/>
        <van-field type="password" placeholder="请输入新密码" label="密码" v-model="password"/>
        <van-field type="password" placeholder="确认新密码" label="确认密码" v-model="repassword"/>
        <van-field type="text" placeholder="请输入验证码" label="验证码" v-model="code" class="codebox">
          <van-button slot="button" size="small" @click="getCode()" class="theme-bg send-btn">{{ time == 60 ? '获取验证码' : time + 's后获取' }}</van-button>
        </van-field>
        <van-field type="text" placeholder="请输入图形验证码" label="图形验证码" v-model="craphicCode" class="codebox">
          <img slot="button" :src="imgUrl" alt="" @click="getGraphCode()">
        </van-field>
        <van-cell>
          <van-button size="large" class="theme-bg loginbtn send-btn" @click="senData()" :loading="loading">确定</van-button>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "index",
    components: {
      TopNav
    },
    data () {
      return {
        loading:false,
        codeLoading:false,
        mobile:'',
        password:'',
        repassword:'',
        code:'',
        time: 60,
        imgUrl: '',
        craphicCode: ''
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getGraphCode: function() {
        this.$api.post('WebApi/Login/Register/buildverifyCodeNew', {type: 'forgot_password'}, res => {
          if(res.data.errCode == '0000'){
            this.imgUrl = res.data.data.url
          }
        })
      },
      getCode: function () {
        if(this.codeLoading) {
          return false
        }
        var _this = this
        var reg = /^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.codeLoading = true
          this.$api.post('WebApi/Login/Register/sendPhoneCode ', {mobile:this.mobile, type: 'forgot_password', remark: '忘记密码手机验证码' }, res => {
            if(res.data.errCode == '0000'){
              this.$toast("发送成功请注意查收");
              var dd = setInterval(function () {
                _this.time--
                if(_this.time <= 0){
                  clearInterval(dd)
                  _this.time = 60
                  _this.codeLoading = false
                }
              },1000)
            }else {
              this.$toast(res.data.desc);
              this.codeLoading = false
            }
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
      senData: function () {
        this.loading = true
        this.$api.post('WebApi/Login/Index/forgotPassword', {mobile:this.mobile,password:this.password,repassword:this.repassword,code:this.code, captcha_code: this.craphicCode}, res => {
          if(res.data.errCode == '0000'){
            this.$toast('找回成功，快去登陆吧');
            this.$router.replace({ name: 'Login' })
          }else{
            this.$toast(res.data.desc);
          }
          this.loading = false
        })
      },
    },
    mounted () {
      this.getGraphCode()
    },
  }
</script>

<style scoped>
  .login{
    background: #fff;
    min-height: 100vh;
  }
  .loginbtn{
    margin-top: 15px;
    border-radius: 10px;
  }
  .login-box{
    padding-top: 15vh;
    padding-bottom: 60px;
    text-align: center;
  }
  .logo{
    width: auto;
    min-width: 120px;
    max-width: 170px;
  }
  .codeimg{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .codebox{
    line-height: 35px;
  }
  .codebox .van-button{
    height: 30px;
    line-height: 30px;
  }
  .restBox::after{
    border-bottom-width:0;
  }
  .send-btn {
    background: #101a86 !important;
  }
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/backpass/index.vue